
export let USER_SERVICE = process.env.REACT_APP_URL_USER_SERVICE;
export let FORM_LINK_URL = process.env.REACT_APP_FORM_LINK_URL;
export let QFIX_FORM_LINK_URL = process.env.REACT_APP_QFIX_FORM_LINK_URL;

let path = window.location.pathname;
export function getDownloadFormUrl(token){
    let url=USER_SERVICE+"/online/admission/form?token="+token
    return url
}

export function getDownloadRecieptUrl(qfix_reference_number){
    let url=FORM_LINK_URL+"printFormDetails?qfixRefNo="+qfix_reference_number;
    if(path.includes('qfixonline')){
        url=QFIX_FORM_LINK_URL+"printFormDetails?qfixRefNo="+qfix_reference_number;
    }
    return url
}

